export class ErrorNotification {
  type: string;
  message: string;
  stack: string;
  location: string;
}
